import { campaignStatusLabel } from '@/lib/campaign-status';
// Port of references/claude-design-source/project/src/primitives.jsx — verbatim
// structure, typed. Icons + small primitives shared across screens.

import type { CSSProperties, ReactNode } from 'react';

interface IconProps {
  d: ReactNode;
  size?: number;
  fill?: string;
  stroke?: string;
  sw?: number;
  style?: CSSProperties;
}

export const Icon = ({ d, size = 14, fill = 'none', stroke = 'currentColor', sw = 1.5, style }: IconProps) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill={fill} stroke={stroke} strokeWidth={sw} strokeLinecap="round" strokeLinejoin="round" style={style}>{d}</svg>
);

export const Icons = {
  dashboard:   <Icon d={<><rect x="2" y="2" width="5" height="6"/><rect x="9" y="2" width="5" height="4"/><rect x="2" y="9.5" width="5" height="4.5"/><rect x="9" y="7.5" width="5" height="6.5"/></>}/>,
  campaigns:   <Icon d={<><path d="M2 11V5l9-2v10l-9-2z"/><path d="M11 6h2.5v4H11"/><path d="M4 11v3"/></>}/>,
  audiences:   <Icon d={<><circle cx="6" cy="6" r="2.4"/><path d="M2 13c0-2.2 1.8-3.6 4-3.6S10 10.8 10 13"/><circle cx="11.5" cy="5.5" r="1.8"/><path d="M9.5 12.5c.5-2 2-3 3.5-3s2.5 1 3 2.4"/></>}/>,
  creatives:   <Icon d={<><rect x="2" y="3" width="12" height="10" rx="1"/><circle cx="6" cy="7" r="1.2"/><path d="m2 11 3.5-3 3 2.5 2-1.5L14 12"/></>}/>,
  reports:     <Icon d={<><path d="M2 13V3"/><path d="M2 13h12"/><rect x="4" y="8" width="2" height="4"/><rect x="7.5" y="5" width="2" height="7"/><rect x="11" y="6.5" width="2" height="5.5"/></>}/>,
  productions: <Icon d={<><path d="M3 2v12l3-2 2 1.5L10 12l3 2V2z"/><path d="M3 6h10"/></>}/>,
  settings:    <Icon d={<><circle cx="8" cy="8" r="2.2"/><path d="M8 1.5v2M8 12.5v2M14.5 8h-2M3.5 8h-2M12.5 3.5l-1.5 1.5M5 11l-1.5 1.5M12.5 12.5 11 11M5 5 3.5 3.5"/></>}/>,
  search:      <Icon d={<><circle cx="7" cy="7" r="4.5"/><path d="m13.5 13.5-3-3"/></>}/>,
  plus:        <Icon d={<><path d="M8 2.5v11M2.5 8h11"/></>}/>,
  chev_d:      <Icon size={10} d={<path d="m3 5 3 3 3-3"/>}/>,
  chev_r:      <Icon size={10} d={<path d="m5 3 3 3-3 3"/>}/>,
  chev_l:      <Icon size={10} d={<path d="m9 3-3 3 3 3"/>}/>,
  star:        <Icon d={<path d="m8 1.5 1.9 4 4.4.6-3.2 3 .8 4.4L8 11.4 4.1 13.5l.8-4.4-3.2-3 4.4-.6z"/>}/>,
  bell:        <Icon d={<><path d="M4 11V7a4 4 0 0 1 8 0v4l1 1.5H3z"/><path d="M6.5 13a1.5 1.5 0 0 0 3 0"/></>}/>,
  filter:      <Icon d={<path d="M2 3h12l-4.5 5.5V13l-3-1.5V8.5z"/>}/>,
  dl:          <Icon d={<><path d="M8 2v9"/><path d="m4.5 7.5 3.5 3.5 3.5-3.5"/><path d="M2.5 13.5h11"/></>}/>,
  layers:      <Icon d={<><path d="M8 2 14 5 8 8 2 5z"/><path d="m2 8 6 3 6-3"/><path d="m2 11 6 3 6-3"/></>}/>,
  refresh:     <Icon d={<><path d="M14 8a6 6 0 0 0-6-6 6.3 6.3 0 0 0-4.4 1.8L2 5.3"/><path d="M2 2v3.3h3.3"/><path d="M2 8a6 6 0 0 0 6 6 6.3 6.3 0 0 0 4.4-1.8L14 10.7"/><path d="M14 14v-3.3h-3.3"/></>}/>,
  more:        <Icon d={<><circle cx="3.5" cy="8" r="1" fill="currentColor"/><circle cx="8" cy="8" r="1" fill="currentColor"/><circle cx="12.5" cy="8" r="1" fill="currentColor"/></>}/>,
  x:           <Icon d={<><path d="m3.5 3.5 9 9M12.5 3.5l-9 9"/></>}/>,
  check:       <Icon d={<path d="m3 8 3.5 3.5L13 5"/>}/>,
  meta:        <Icon d={<path d="M2 8c1-3 3-5 5-5s3 2 4 4.5S13 13 11 13s-3-2-4-4.5S5 4 3 4"/>}/>,
  ctv:         <Icon d={<><rect x="1.5" y="3" width="13" height="8" rx="1"/><path d="M5 13.5h6M8 11v2.5"/></>}/>,
  dsp:         <Icon d={<><rect x="1.5" y="2.5" width="6" height="5" rx=".5"/><rect x="8.5" y="2.5" width="6" height="3" rx=".5"/><rect x="1.5" y="8.5" width="4" height="5" rx=".5"/><rect x="6.5" y="8.5" width="8" height="5" rx=".5"/></>}/>,
  play:        <Icon d={<path d="M4 3v10l8-5z" fill="currentColor"/>}/>,
  pause:       <Icon d={<><rect x="4" y="3" width="2.5" height="10" fill="currentColor"/><rect x="9.5" y="3" width="2.5" height="10" fill="currentColor"/></>}/>,
  pulse:       <Icon d={<path d="M1 8h3l1.5-4 2 8 1.5-5L11 9.5h4"/>}/>,
  calendar:    <Icon d={<><rect x="2" y="3" width="12" height="11" rx="1"/><path d="M2 6h12M5 2v3M11 2v3"/></>}/>,
  ticket:      <Icon d={<><path d="M2 6V4a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v2"/><path d="M2 10v2a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-2"/><path d="M2 6a2 2 0 0 1 0 4"/><path d="M14 6a2 2 0 0 0 0 4"/><path d="M8 4v8" strokeDasharray="1 2"/></>}/>,
  venue:       <Icon d={<><path d="M2 14h12"/><path d="M3 14V6"/><path d="M13 14V6"/><path d="M2 6c2-1.5 4-1.5 6-1.5s4 0 6 1.5"/><path d="M6 14V8a2 2 0 0 1 4 0v6"/></>}/>,
  copy:        <Icon d={<><rect x="4" y="4" width="9" height="9" rx="1"/><path d="M10.5 4V3a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v6.5a1 1 0 0 0 1 1H4"/></>}/>,
  moon:        <Icon d={<path d="M13 9.5A5.5 5.5 0 1 1 6.5 3a4.5 4.5 0 0 0 6.5 6.5z"/>}/>,
  sun:         <Icon d={<><circle cx="8" cy="8" r="2.8"/><path d="M8 1.5v2M8 12.5v2M14.5 8h-2M3.5 8h-2M12.4 3.6l-1.4 1.4M5 11l-1.4 1.4M12.4 12.4 11 11M5 5 3.6 3.6"/></>}/>,
  dollar:      <Icon d={<><path d="M8 2v12"/><path d="M11 4.5H6.5a2 2 0 0 0 0 4h3a2 2 0 0 1 0 4H5"/></>}/>,
  halo:        <Icon d={<><ellipse cx="8" cy="3.5" rx="5" ry="1.4"/><circle cx="8" cy="8" r="2.2"/><path d="M3.5 14c0-2.2 2-3.6 4.5-3.6s4.5 1.4 4.5 3.6"/></>}/>,
  user:        <Icon d={<><circle cx="8" cy="5.5" r="2.8"/><path d="M2.5 14c0-2.5 2.5-4.5 5.5-4.5s5.5 2 5.5 4.5"/></>}/>,
  shield:      <Icon d={<><path d="M8 2 3 4v4.5c0 3 2 5 5 5.5 3-.5 5-2.5 5-5.5V4z"/><path d="M6 8 7.5 9.5 10.5 6.5"/></>}/>,
  terminal:    <Icon d={<><rect x="1.5" y="2.5" width="13" height="11" rx="1"/><path d="m4 6 2 2-2 2"/><path d="M8 10.5h4"/></>}/>,
  history:     <Icon d={<><path d="M2 8a6 6 0 1 0 1.8-4.3"/><path d="M2 2v3h3"/><path d="M8 5v3.5L10.5 10"/></>}/>,
  send:        <Icon d={<><path d="m2 8 12-5-5 12-1.5-5.5z"/><path d="m7.5 9.5 1.5-2"/></>}/>,
  trash:       <Icon d={<><path d="M3 5h10M6.5 5V3.5h3V5M5 5l.5 8.5h5L11 5"/></>}/>,
  key:         <Icon d={<><circle cx="5" cy="10.5" r="2.8"/><path d="m7 8.5 6.5-6.5"/><path d="m11 4.5 1.8 1.8"/><path d="m9.3 6.2 1.4 1.4"/></>}/>,
  lock:        <Icon d={<><rect x="3.5" y="7" width="9" height="7" rx="1"/><path d="M5.5 7V5a2.5 2.5 0 0 1 5 0v2"/></>}/>,
  // Data Pipeline — small three-node flow glyph, house icon stroke style.
  flow:        <Icon d={<><circle cx="3.2" cy="3.8" r="1.7"/><circle cx="3.2" cy="12.2" r="1.7"/><circle cx="12.6" cy="8" r="1.9"/><path d="M4.8 4.6 10.7 7.2"/><path d="M4.8 11.4 10.7 8.8"/></>}/>,
} as const;

export type IconKey = keyof typeof Icons;

export type Channel = 'meta' | 'ctv' | 'dsp';
export type StatusKind =
  | 'live'
  | 'paused'
  | 'draft'
  // Armed for auto-launch. Still `draft` on the wire — see lib/campaign-status.ts.
  | 'armed'
  | 'ready_to_publish'
  | 'ended'
  | 'archived'
  | 'paused_by_system' | 'pausing' | 'scheduled' | 'starting' | 'partially_active' | 'needs_attention' | 'unverified';

export const ChannelPill = ({ channel }: { channel: Channel }) => {
  const lbl = ({ meta: 'META', ctv: 'CTV', dsp: 'DISPLAY' } as const)[channel];
  return <span className={`ch ${channel}`}><span className="gl"/>{lbl}</span>;
};

export const StatusDot = ({ s, label }: { s: StatusKind; label?: string }) => (
  <span className={`status ${s}`}>
    {/* Armed swaps the dot for a bolt rather than adding one — the column keeps
        exactly one mark per row, and the shape says "this one acts on its own". */}
    {s === 'armed' ? <span className="d bolt">⚡</span> : <span className="d"/>}
    {label ?? (s === 'archived' ? s : campaignStatusLabel(s))}
  </span>
);

export const PaceBar = ({ pace }: { pace: number | null | undefined }) => {
  if (!pace) return <span className="muted tnum" style={{ fontSize: 10 }}>—</span>;
  const pct = Math.min(120, pace * 100);
  const cls = pct < 80 ? 'bad' : pct > 110 ? 'warn' : '';
  return (
    <div className="pace">
      <div className="pace-bar"><i className={cls} style={{ width: `${Math.min(100, pct)}%` }}/><span className="tgt" style={{ left: '85%' }}/></div>
      <span style={{ color: cls === 'bad' ? 'var(--bad)' : cls === 'warn' ? 'var(--warn)' : 'var(--ink-1)' }}>{pace.toFixed(2)}×</span>
    </div>
  );
};

interface SparklineProps {
  data: ReadonlyArray<number | null>;
  w?: number;
  h?: number;
  color?: string;
}

export const Sparkline = ({ data, w = 80, h = 22, color }: SparklineProps) => {
  const finite = data.filter((value): value is number => value !== null);
  if (!finite.length) return null;
  const min = Math.min(...finite);
  const max = Math.max(...finite);
  const r = max - min || 1;
  const step = data.length > 1 ? w / (data.length - 1) : 0;
  const segments: Array<Array<readonly [number, number]>> = [];
  let segment: Array<readonly [number, number]> = [];
  data.forEach((value, index) => {
    if (value === null) {
      if (segment.length) segments.push(segment);
      segment = [];
      return;
    }
    segment.push([
      index * step,
      h - ((value - min) / r) * (h - 2) - 1,
    ]);
  });
  if (segment.length) segments.push(segment);
  return (
    <svg className="spark" width={w} height={h} viewBox={`0 0 ${w} ${h}`} aria-label="Trend; gaps indicate unpublished days">
      {segments.map((points, index) => {
        const path = points.map(([x, y], pointIndex) => (
          `${pointIndex === 0 ? 'M' : 'L'}${x.toFixed(1)},${y.toFixed(1)}`
        )).join(' ');
        if (points.length === 1) {
          const [pointX, pointY] = points[0]!;
          return (
            <circle
              key={index}
              cx={pointX}
              cy={pointY}
              r="1.5"
              style={{ fill: color ?? 'var(--accent)' }}
            />
          );
        }
        const firstPoint = points[0]!;
        const lastPoint = points[points.length - 1]!;
        const area = `${path} L${lastPoint[0]},${h} L${firstPoint[0]},${h} Z`;
        return (
          <g key={index}>
            <path className="area" d={area}/>
            <path d={path} style={color ? { stroke: color } : undefined}/>
          </g>
        );
      })}
    </svg>
  );
};

export const fmt = {
  $: (n: number) => n >= 1000 ? `$${(n / 1000).toFixed(n >= 10000 ? 0 : 1)}k` : `$${n}`,
  $full: (n: number) => '$' + Math.round(n).toLocaleString(),
  // KPI formatters — used in every kpi-val. Always full numbers with
  // thousands-separators, rounded to the nearest integer. No K/M abbreviations.
  $kpi: (n: number) => '$' + Math.round(n).toLocaleString(),
  nKpi: (n: number) => Math.round(n).toLocaleString(),
  n: (n: number) => n >= 1e6 ? (n / 1e6).toFixed(2) + 'M' : n >= 1e3 ? (n / 1e3).toFixed(n >= 1e4 ? 0 : 1) + 'k' : '' + n,
  pct: (n: number) => n.toFixed(2) + '%',
  cur: (n: number) => '$' + n.toFixed(2),
} as const;

// Accounting-layout money cell: `$` flush-left, whole number flush-right, tabular
// figures so digit places line up column-to-column while scrolling. Negatives in
// red parentheses; the aria-label carries the real signed value so assistive tech
// reads "-$1,234" as one token regardless of the split nodes. `value` is dollars
// (callers convert cents with `/100`); `dp` is decimal places (0 = whole dollars).
export function MoneyCell({ value, dp = 0 }: { value: number | null | undefined; dp?: number }) {
  if (value == null || Number.isNaN(value)) {
    return <span className="acct acct-empty">—</span>;
  }
  const neg = value < 0;
  const digits = Math.abs(value).toLocaleString(undefined, {
    minimumFractionDigits: dp,
    maximumFractionDigits: dp,
  });
  // A phone KPI tile shows whole dollars: the twin `.acct-whole` span is
  // display:none everywhere else, so the desktop text node stays one run
  // (splitting it changes kerning and the pixel-parity check).
  const [whole, fraction] = splitFraction(digits, dp);
  return (
    <span className={'acct' + (neg ? ' acct-neg' : '')} aria-label={(neg ? '-$' : '$') + digits}>
      <span className="acct-cur">$</span>
      <span className="acct-val acct-full">{neg ? `(${digits})` : digits}</span>
      {fraction && <span className="acct-val acct-whole" aria-hidden="true">{neg ? `(${whole})` : whole}</span>}
    </span>
  );
}

/** "1,234.56" → ["1,234", ".56"]. Only a decimal point counts (a thousands comma
 * before three digits stays put); a locale with a decimal comma keeps its cents inline. */
export function splitFraction(digits: string, dp = 2): [string, string] {
  if (dp === 0) return [digits, ''];
  const m = /^(.*?)(\.\d{1,2})$/.exec(digits);
  return m ? [m[1]!, m[2]!] : [digits, ''];
}

export interface ProductionPosterData {
  posterBg: string;
  posterFg: string;
  poster: string;
  tag?: string | null;
}

interface PosterProps {
  production: ProductionPosterData;
  big?: boolean;
}

export const Poster = ({ production, big = false }: PosterProps) => (
  <div className="poster" style={{ background: production.posterBg, color: production.posterFg }}>
    <div className="stripes"/>
    <div className="pt" style={{ fontSize: big ? 22 : 16, color: production.posterFg }}>
      {production.poster.split('\n').map((l, i) => <div key={i}>{l}</div>)}
    </div>
    {big && <div style={{ position: 'absolute', top: 8, left: 8, fontFamily: 'var(--font-mono)', fontSize: 9, letterSpacing: '.12em', color: production.posterFg, opacity: .7 }}>SHUBERT · {production.tag}</div>}
  </div>
);
